import client from './client';
import { OverviewStats, ChartData } from '../types/stats';

export async function getOverview(): Promise<OverviewStats> {
  const res = await client.get('/api/admin/stats/overview');
  return res.data?.data ?? res.data;
}

export async function getCharts(): Promise<ChartData> {
  const res = await client.get('/api/admin/stats/charts');
  const raw = res.data?.data ?? res.data ?? {};
  // The gateway only aggregates order + signup charts here; top_clusters and
  // ratings_distribution live on the overview endpoint. Default every array so
  // a missing key can never crash the dashboard.
  return {
    daily_revenue: raw.daily_revenue ?? [],
    daily_signups: raw.daily_signups ?? [],
    orders_by_status: raw.orders_by_status ?? [],
    top_clusters: raw.top_clusters ?? [],
    ratings_distribution: raw.ratings_distribution ?? [],
    payment_methods: raw.payment_methods ?? [],
  };
}
